"use client";
import PerCurriculum from './PerSemCurriculum'

export default function HeadingWithBullets({
  data,
  courseCurriculumTitle,
}: {
  data: { heading: string; subtitle: string }[];
  courseCurriculumTitle: string
}) {
  return (
    <>
      {data.map((item: any, index) => (
        <PerCurriculum
          courseCurriculumTitle={courseCurriculumTitle}
          index={index}
          item={item}
        />
      ))}
    </>
  );
}
